@let coaching = coaching$ | async;

<app-generic-view
  [backgroundImage]="'url(' + coaching?.thumbnails.medium + ')'"
  [information]="coaching"
  [comments$]="comments"
  [sameContributor$]="sameContributor$"
  (getComments)="getComments()"
  (onLikeClick)="onLikeClick($event)"
  (onEditPost)="editCoaching(coaching.id, $event)"
  [editLoading$]="editLoading$">
  <kin-coaching-player
    (onFavoriteClick)="onFavoriteClick(coaching)"
    [coachingIntervals$]="intervals$"
    [informations$]="coaching$" />
</app-generic-view>
